import { useState } from 'react';
import { Input, Divider, Form, Select } from 'antd';
import { AllCurrencySync, AddUpdatUpdateCurrencyApi } from '../../../api/request/cashDeposit/usdConversion';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import LoadableButton from '../../../components/buttons/LoadableButton';
import ConversionHistory from './components/ConversionHistory';

function UsdConversion() {

    const [form] = Form.useForm();
    const userDetails = useSelector((state) => state.user.userDetails);
    let isSalesManager = userDetails?.roleId === 6;

    const [usdValue, setUsdValue] = useState('1');
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [currencyid, setCurrencyid] = useState()
    const [isRefresh, setIsRefresh] = useState(false);

    const getAllCurrencySync = async () => {
        try {
            const payload = {
                BaseCurrency: "USD",
                TargetCurrency: "INR",
                Amount: 1
            }
            const { data } = await AllCurrencySync(new URLSearchParams(payload).toString());
            if (data?.success) {
                form.setFieldValue('amount', data?.data?.exchangeRate)
            }
        }
        catch (error) { }
    }

    const handleUpdate = async (values) => {
        setIsUpdateLoading(true);
        try {
            const payload = {
                ...values,
                currencyId: currencyid,
            }
            const { data } = await AddUpdatUpdateCurrencyApi(payload);
            if (data?.success) {
                form.resetFields();
                setIsRefresh(!isRefresh);
                toast.success(data?.message);
            }
            setIsUpdateLoading(false);
        }
        catch (error) { setIsUpdateLoading(false) }
    }

    return (
        <>
            {!isSalesManager && <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full">
                <Form className='w-full' autoComplete="off" form={form} onFinish={handleUpdate}>
                    <div className="px-4 lg:px-6 flex justify-between items-center">
                        <p className="text-[#2F2B3D] text-title font-semibold">INR / USD</p>
                        <div className='flex items-center'>
                            <LoadableButton
                                type='submit'
                                className="flex items-center bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500"
                                lable='Update'
                                loadingLable='Updating'
                                isLoading={isUpdateLoading}
                                disabled={isUpdateLoading}
                            />
                        </div>
                    </div>
                    <Divider />
                    <div className='px-4 lg:px-6 mb-7'>
                        <div className="grid sm:grid-cols-4 lg:grid-cols-4 gap-5">
                            <div className="input-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium block mb-1">USD</label>
                                <Input disabled defaultValue={usdValue} className="mt-1 w-full ps-4 py-2" prefix={<span>$</span>} />
                            </div>
                            <div className="input-white" >
                                <label className="text-base text-[#2F2B3DCC] font-medium block mb-1">Amount In INR</label>
                                <Form.Item name="amount" rules={[{ required: true, message: 'Please enter amount' }]}>
                                    <Input type='number' placeholder="Amount" className="mt-1 w-full ps-4 py-2" prefix={<span className='text-[#2F2B3DCC]'>₹</span>} />
                                </Form.Item>
                            </div>
                            <div className='ant-select-selector-white'>
                                <label className="text-base text-[#2F2B3DCC] font-medium block mb-1">Currency type</label>
                                <Form.Item name="currencyType" rules={[{ required: true, message: 'Please currency type.' }]}>
                                    <Select size='large' placeholder='Select currency type' className='w-full mt-1 '
                                        options={[{ value: 1, label: 'Deposit' }, { value: 2, label: 'Withdraw' }]}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>}
            <div className='grid sm:grid-cols-2 gap-5'>
                <ConversionHistory type={'Deposit'} setCurrencyid={setCurrencyid} isRefresh={isRefresh} />
                <ConversionHistory type={'Withdraw'} setCurrencyid={setCurrencyid} isRefresh={isRefresh} />
            </div>

        </>
    )
}

export default UsdConversion
